import { useMissionsPusher } from '../../domains/missions/hooks/useMissionsPusher';
import { useMissionCompletionModal } from '../../domains/missions/hooks/useMissionCompletionModal';

/**
 * Invisible side-effect component that wires up real-time missions behaviour:
 * - `useMissionsPusher`   — subscribes to the per-user gamification channel and refetches
 *                           missions on `mission_progress` / reconnect / app foreground.
 * - `useMissionCompletionModal` — shows the "Mission Completed" modal once per assignment.
 *
 * Mounted inside `PromotionsModalsContextProvider` (within `GamificationContextProvider`)
 * so it has access to both the react-query cache and `openModalUnique`. Both hooks are
 * internally gated (feature flag + auth), so this renders nothing and no-ops when missions
 * or Pusher are disabled.
 */
function MissionsRealtimeManager() {
  useMissionsPusher();
  useMissionCompletionModal();

  return null;
}

export default MissionsRealtimeManager;
